export default "__VITE_ASSET__DDuq3MA1__"